import React, { useRef } from 'react';
import { ActionTooltip, Button, Icon, Popover } from '@gravity-ui/uikit';
import { cn } from '../classname';
import { i18n } from '../i18n/common';
import { isFunction } from '../lodash';
import { ToolbarTooltipDelay } from './const';
import './ToolbarButton.css';
const b = cn('toolbar-button');
export function ToolbarButton({ className, id, title, hotkey, editor, icon, disabledPopoverVisible = true, hintWhenDisabled, exec, focus, onClick, isActive, isEnable, }) {
    var _a;
    const active = isActive(editor);
    const enabled = isEnable(editor);
    const disabled = !active && !enabled;
    const buttonRef = useRef(null);
    const titleText = isFunction(title) ? title() : title;
    const hideHintWhenDisabled = hintWhenDisabled === false || !disabledPopoverVisible || !disabled;
    const hintWhenDisabledText = typeof hintWhenDisabled === 'string'
        ? hintWhenDisabled
        : typeof hintWhenDisabled === 'function'
            ? hintWhenDisabled()
            : i18n('toolbar_action_disabled');
    return (React.createElement(Popover, { content: hintWhenDisabledText, disabled: hideHintWhenDisabled, tooltipContentClassName: b('action-disabled-tooltip'), placement: ['bottom'] },
        React.createElement(ActionTooltip, { openDelay: ToolbarTooltipDelay.Open, closeDelay: ToolbarTooltipDelay.Close, title: titleText, hotkey: hotkey },
            React.createElement(Button, { ref: buttonRef, size: "m", selected: active, disabled: disabled, view: active ? 'normal' : 'flat', onClick: () => {
                    focus();
                    exec(editor);
                    onClick === null || onClick === void 0 ? void 0 : onClick(id);
                }, className: b(null, [className]), extraProps: { 'aria-label': titleText } },
                React.createElement(Icon, { data: icon.data, size: (_a = icon.size) !== null && _a !== void 0 ? _a : 16 })))));
}
